import { Segment } from '../../../../../../reducers/gerenciadorPrecos/segmentos';
import { SegmentsCurve } from '../../RegrasDePreco/lib';

type SegmentsModel = {
  value: Partial<Record<string, string[]>>;
  cache: Partial<Record<string, DataItem[]>>;
};

type Key = Segment['field'] | SegmentsCurve | 'storeIds' | 'clusters';

type SegmentSetModel = {
  value: string;
  level: 'productId' | Key;
} & Record<string, unknown>;

export const getSegmentsModel = ({ value, cache }: SegmentsModel) => {
  const segmentsList = new Set<SegmentSetModel>([]);
  Object.entries(value).forEach(([key, value = []]) => {
    const level = key === 'productIds' ? 'productId' : (key as Key);

    if (key.match(/categoryLevel/)) {
      value.forEach(item => {
        segmentsList.add({
          level,
          value: item,
        });
      });
    } else {
      cache[key]?.forEach(item => {
        segmentsList.add({
          level,
          value: item.value,
          description: item.description,
        });
      });
    }
  });
  return Array.from(segmentsList);
};

export const checkIsSegmentEmpty = (value: Partial<Record<string, string[]>>): boolean => {
  for (const key in value) {
    const isEmpty = !!value[key]?.length;
    if (isEmpty) return false;
  }
  return true;
};
